// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const CadOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M5.9 12.06c0-.92.37-1.42 1.01-1.42.58 0 .93.42.93 1h1.24v-.15c0-1.15-.91-1.92-2.18-1.92-1.49 0-2.32.96-2.32 2.49v.56c0 1.52.83 2.48 2.32 2.48 1.26 0 2.18-.76 2.18-1.89v-.16H7.84c0 .57-.35.98-.93.98-.64 0-1.01-.5-1.01-1.4v-.57zM10.68 15l.35-1.22h1.65l.34 1.22h1.38l-1.7-5.33H11.1L9.4 15h1.3zm1.21-4.18l.56 2.02h-1.18l.57-2.02h.05zm3.07-1.15V15h2.1c1.64 0 2.4-1.03 2.4-2.69 0-1.64-.74-2.64-2.4-2.64h-2.1zm1.29 1.02h.6c1 0 1.29.72 1.29 1.65 0 1.32-.55 1.64-1.3 1.64h-.59v-3.29z","fill":"currentColor"}},{"tag":"rect","attrs":{"height":"18.5","rx":".75","stroke-linecap":"square","stroke-linejoin":"round","stroke-width":"1.5","stroke":"currentColor","width":"18.5","x":"2.75","y":"2.75"}}]},"name":"cad","theme":"outlined"};

const CadOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={CadOutlinedSvg} />;
  CadOutlined.displayName = 'CadOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(CadOutlined);
